import { useQuery } from "@tanstack/react-query";
import { Download } from "lucide-react";
import { api } from "@/lib/api";
import RESELLERS from "@/lib/resellers.json";

const COLS = [["name", "Magasin"], ["address", "Adresse"], ["zip", "Code postal"], ["city", "Ville"], ["dept_name", "Zone"], ["phone", "Téléphone"], ["email", "Email"], ["source", "Source de l'email"]];
const cell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

export function ResellersAdmin() {
  const { data } = useQuery({ queryKey: ["admin-reseller-emails"], queryFn: () => api.get("/admin/reseller-emails").then((r) => r.data) });
  const emails = data && typeof data === "object" ? data : {};
  const rows = RESELLERS.map((r) => ({ ...r, ...(emails[r.id] || {}) }));
  const found = rows.filter((r) => r.email).length;
  const download = () => {
    const csv = [COLS.map(([, l]) => cell(l)).join(";"), ...rows.map((r) => COLS.map(([k]) => cell(r[k])).join(";"))].join("\r\n");
    const url = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = url; a.download = "revendeurs-ozentya.csv"; a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div data-testid="admin-resellers">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl">Revendeurs ({rows.length})</h2>
          <p data-testid="admin-resellers-email-count" className="mt-1 text-sm text-[var(--parchment)]/85">{found} email{found > 1 ? "s" : ""} trouvé{found > 1 ? "s" : ""} en ligne. Les emails ne sont jamais affichés sur le site public.</p>
        </div>
        <button onClick={download} data-testid="admin-resellers-download" className="inline-flex h-11 items-center gap-2 rounded-full bg-[var(--gold)] px-6 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ink)]">
          <Download className="h-4 w-4" /> Télécharger le fichier (Excel / CSV)
        </button>
      </div>
      <div className="mt-6 overflow-x-auto rounded-sm border border-[var(--line)]">
        <table className="w-full min-w-[720px] text-left text-sm">
          <thead className="bg-[var(--ink-2)] text-xs uppercase tracking-[0.12em] text-[var(--gold-soft)]">
            <tr><th className="p-3">Magasin</th><th className="p-3">Ville</th><th className="p-3">Téléphone</th><th className="p-3">Email</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`admin-reseller-row-${r.id}`} className="border-t border-[var(--line)]">
                <td className="p-3">{r.name}</td>
                <td className="p-3 text-[var(--parchment)]/85">{r.zip} {r.city}</td>
                <td className="p-3 text-[var(--parchment)]/85">{r.phone || "—"}</td>
                <td className="p-3">{r.email ? <a href={`mailto:${r.email}`} className="text-[var(--gold-soft)] underline" title={r.source}>{r.email}</a> : <span className="text-[var(--parchment)]/60">non trouvé</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
